import React from "react";
import "./Footer.css";
import Analytics from "../Analytics";
import Floaticon from "../Floaticon";

function Footer() {
  const footerYear = new Date().getFullYear();

  return (
    <>
      <div className="footer_container">
        <p>
          &copy; {footerYear} Accenture. All Rights Reserved Ignite Accenture. Powered by Learning Experiences - L&TT
          <Analytics />
        </p>
      </div>
      <div className="float-icon-wrap">
        {/* <Floaticon /> */}
      </div>
    </>
  );
}

export default Footer;
